import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d95c2286"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d95c2286')) {
      api.createRecord('d95c2286', component.options)
    } else {
      api.reload('d95c2286', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d95c2286", function () {
      api.rerender('d95c2286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/traveler/index.vue"
export default component.exports